<template>
  <div>
    <div class="form-group" v-bind:class="{'has-error': fieldErrors('firstName')}">
      <label for="firstName">* First Name</label>
      <input @input="updateFormField" :value="driver.firstName" id="firstName" name="firstName" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('firstName')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('middleName')}">
      <label for="middleName">Middle Name</label>
      <input @input="updateFormField" :value="driver.middleName" id="middleName" name="middleName" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('middleName')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('lastName')}">
      <label for="lastName">* Last Name</label>
      <input @input="updateFormField" :value="driver.lastName" id="lastName" name="lastName" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('lastName')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('dob')}">
      <label for="dob">* Date of Birth example mm/dd/yyyy</label>
      <input @input="updateFormField" :value="driver.dob" id="dob" name="dob" type="date" class="form-control">
      <error-list v-bind:errors="fieldErrors('dob')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('driversLicenseNumber')}">
      <label for="driversLicenseNumber">* Drivers License Number</label>
      <input @input="updateFormField" :value="driver.driversLicenseNumber" id="driversLicenseNumber" name="driversLicenseNumber" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('driversLicenseNumber')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('driversLicenseState')}">
      <label for="driversLicenseState">* Drivers License State / Province</label>
      <select @input="updateFormField" :value="driver.driversLicenseState" id="driversLicenseState" name="driversLicenseState" class="form-control">
        <option value="">Please Select</option>
        <optgroup v-for="optgroup in stateOptions" :label="optgroup.label" :key="optgroup.label">
          <option v-for="(label,value) in optgroup.options" :value="value" :key="value">
            {{ label }}
          </option>
        </optgroup>
      </select>
      <error-list v-bind:errors="fieldErrors('driversLicenseState')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('email')}">
      <label for="email">* Email</label>
      <input @input="updateFormField" :value="driver.email" id="email" name="email" type="email" class="form-control">
      <error-list v-bind:errors="fieldErrors('email')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('phoneNumber')}">
      <label for="phoneNumber">* Phone Number</label>
      <input @input="updateFormField" :value="driver.phoneNumber" id="phoneNumber" name="phoneNumber" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('phoneNumber')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('faxNumber')}">
      <label for="faxNumber">Fax Number</label>
      <input @input="updateFormField" :value="driver.faxNumber" id="faxNumber" name="faxNumber" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('faxNumber')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('street')}">
      <label for="street">* Street</label>
      <input @input="updateFormField" :value="driver.street" id="street" name="street" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('street')" />
     </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('city')}">
      <label for="city">* City</label>
      <input @input="updateFormField" :value="driver.city" id="city" name="city" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('city')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('stateProvinceRegion')}">
      <label for="stateProvinceRegion">* State/Prov/Region</label>
      <select @input="updateFormField" :value="driver.stateProvinceRegion" id="stateProvinceRegion" name="stateProvinceRegion" class="form-control">
        <optgroup v-for="optgroup in stateOptions" :label="optgroup.label" :key="optgroup.label">
          <option v-for="(label,value) in optgroup.options" :value="value" :key="value">
            {{ label }}
          </option>
        </optgroup>
      </select>
      <error-list v-bind:errors="fieldErrors('stateProvinceRegion')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('zip')}">
      <label for="zip">* Zip/Postal</label>
      <input @input="updateFormField" :value="driver.zip" id="zip" name="zip" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('zip')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('country')}">
      <label for="country">* Country</label>
      <select @input="updateFormField" :value="driver.country" id="country" name="country" class="form-control">
        <option value>Please Select</option>
        <option v-for="(label, value) in countryOptions" :value="value" :key="value">{{ label }}</option>
      </select>
      <error-list v-bind:errors="fieldErrors('country')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('otherDrivers')}">
      <label for="otherDrivers">Other Drivers</label>
      <input @input="updateFormField" :value="driver.otherDrivers" id="otherDrivers" name="otherDrivers" type="textarea" class="form-control">
      <error-list v-bind:errors="fieldErrors('otherDrivers')" />
    </div>

  </div>
</template>

<script>

import ErrorList from "./ErrorList.vue"
import { mapState, mapActions } from 'vuex';

export default {
  name: 'DriverForm',
  components: {
    ErrorList,
  },
  props: [],
  data: function() {
    return {
    }
  },
  methods: {
    ...mapActions([
      'updateDriverField',
    ]),
    fieldErrors: function(fieldId) {
      let formErrors = this.driverErrors
      if (!formErrors) {
        return false;
      }
      if (!formErrors.hasOwnProperty(fieldId)) {
        return false
      }
      return formErrors[fieldId]
    },
    updateFormField: function(e) {
      let payload = {
        fieldkey: e.target.name,
        val: e.target.value,
      }
      this.updateDriverField(payload)
    },
  },
  computed: {
    ...mapState([
      'driver',
      'driverErrors',
      'stateOptions',
      'countryOptions',
    ]),
  },
}
</script>

<style>
</style>
